export default __webpack_public_path__ + "static/media/postman.587cdcf3.jpg";